const ar = {
  common: {
    dailyLimit: "تم الوصول إلى الحد اليومي. يرجى العودة غدًا.",
    loading: "جارٍ التحميل...",
    serverError: "خطأ في الخادم",
  },
  intro: { playNow: "العب الآن", knowMore: "اعرف المزيد" },
  login: {
    fillFields: "يرجى ملء جميع الحقول!",
    invalid: "رقم غير صحيح",
    title: "تسجيل الدخول للعبة",
    number: "أدخل رقم الاتصال",
    numberLabel: "أدخل رقم الهاتف المحمول",
    numberPlaceholder: "رقم الهاتف",
    password: "أدخل كلمة المرور",
    login: "تسجيل الدخول",
    subscribeLink: "لست مسجلاً؟ اشترك",
    lowbalance: "رصيدك غير كافٍ. يرجى إعادة التعبئة والمحاولة مرة أخرى.",
    inprocess: "جاري خصم الرسوم. يرجى الانتظار قليلاً.",
    invalidNumber: "أدخل رقم هاتف صالح.",
    errorMsg: "حدث خطأ ما!",
    notSub: "لا يوجد اشتراك",
  },
  register: {
    fillFields: "يرجى ملء جميع الحقول!",
    title: "اشترك للبدء",
    name: "أدخل الاسم",
    number: "أدخل رقم الاتصال",
    numberLabel: "أدخل رقم الهاتف المحمول",
    numberPlaceholder: "رقم الهاتف",
    password: "أدخل كلمة المرور",
    subscribe: "اشترك",
    loginLink: "مسجل بالفعل؟ تسجيل الدخول",
    dailyPass: "بطاقة يومية",
    dailyDesc: "24 ساعة من الألعاب",
    weeklyPass: "بطاقة أسبوعية",
    weeklyDesc: "7 أيام من الوصول",
    monthlyPass: "بطاقة شهرية",
    monthlyDesc: "30 يومًا من الألعاب",
    privacy: "ملحق الخصوصية",
    acceptPrivacy: "يرجى قبول ملحق الخصوصية",
    paymentNote: "الدفع عبر الرصيد الرئيسي أو M-Pesa",
    lowbalance: "رصيدك غير كافٍ. يرجى إعادة التعبئة والمحاولة مرة أخرى.",
    inprocess: "جاري خصم الرسوم. يرجى الانتظار قليلاً.",
    redirect: "يرجى الانتظار، سيتم توجيهك لتأكيد اشتراكك",
    subSuccess:
      "ستتلقى رسالة تأكيد الاشتراك، يرجى تأكيدها. بعد نجاح الاشتراك اضغط الزر أدناه للدخول.",
    invalidNumber: "أدخل رقم هاتف صالح.",
    alreadySub:
      "أنت مشترك بالفعل. للدخول إلى الخدمة، اضغط زر 'انقر هنا' أدناه",
    errorMsg: "حدث خطأ ما!",
    clickHere: "انقر هنا",
    notSub: "لا يوجد اشتراك",
  },
  home: { title: "مستويات اللعبة" },
  account: {
    account_subtitle: "لاعب لعبة شيت المخفية",
    pointText: "إجمالي النقاط",
    currentlevel: "المستوى الحالي",
    gameprogress: "تقدم اللعبة",
    levelprogress: "تقدم المستوى",
    btn: "إلغاء الاشتراك",
    unsubTitle: "تأكيد إلغاء الاشتراك",
    unsubText:
      "هل أنت متأكد أنك تريد إلغاء الاشتراك من خطتك الحالية؟ قد تفقد الوصول إلى الألعاب المميزة والفوائد النشطة.",
    unsubCancel: "لا",
    unsubConfirm: "نعم",
    errorMsg: "حدث خطأ ما!",
    nameUpdated: "تم تحديث الاسم بنجاح!",
    editProfile: "تعديل الملف",
    save: "حفظ",
    cancel: "إلغاء",
    wheelSpin: "عجلة الحظ",
    locked: "مقفل",
    completeLevel10: "أكمل المستوى 10",
    alreadySpin: "لقد لعبت اليوم",
    goHome: "الذهاب للرئيسية",
    userHistory: "سجل المستخدم",
  },
  level: {
    level: "المستوى",
    subtitle: "اعثر على الشيء الصحيح!",
    tapPuzzle: "اضغط لفتح اللغز",
    puzzleTitle: "لغز",
    chooseObj: "اختر الشيء الصحيح",
    gameOver: "انتهت اللعبة",
    usedTries: "لقد استخدمت جميع المحاولات",
    restart: "إعادة",
    home: "الرئيسية",
    wrong: "خطأ! حاول مرة أخرى",
    correct: "صحيح",
    loading: "جارٍ التحميل...",
    silverUnlocked: "تم فتح الشيت الفضي!",
    goldenUnlocked: "تم فتح الشيت الذهبي!",
    diamondUnlocked: "تم فتح الشيت الماسي!",
    exploreNow: "استكشف الآن",
    claimReward: "احصل على المكافأة",
    timeLeft: "الوقت المتبقي",
  },
  history: {
    levelHistory: "سجل مستويات المستخدم",
    spinHistory: "سجل العجلة",
    goldenTitle: "مكافأة الشيت الذهبي",
    diamondTitle: "مكافأة الشيت الماسي",
    noHistory: "لا يوجد سجل",
    level: "المستوى",
    points: "النقاط",
    date: "التاريخ",
    riddle: "اللغز",
    answer: "الإجابة",
    spin: "الدوران",
    goldenReward: "مكافأة الشيت الذهبي",
    reward: "المكافأة",
    goldenRewardLabel: "مكافأة ذهبية",
    type: "النوع",
    diamond: "ماسي",
    noDiamond: "لا توجد مكافأة ماسية",
  },
  silver: {
    wonPrize: "الجائزة",
    clickOpen: "اضغط للفتح",
    opening: "جاري الفتح...",
    spinning: "تدور...",
    spinWheel: "أدر العجلة",
    youWon: "لقد فزت",
    nextLevel: "المستوى التالي",
  },
  golden: { congrats: "تهانينا!", claimPrize: "احصل على الجائزة" },
  diamond: {
    title: "أرشيف الماس",
    claimAll: "احصل على كل المكافآت",
    hint: "اضغط على الظرف الماسي للفتح!",
    data: "بيانات",
    points: "نقاط",
  },
  finish: {
    gameOver: "انتهت اللعبة",
    clickEnvelopes: "اضغط على الأظرف لكشف المكافآت",
    screenshotTip: "التقط صورة وشارك فوزك مع أصدقائك!",
    allCollected: "تم جمع الكل!",
    finalText: "لقد جمعت كل الكنوز المخفية. تحقق من حسابك لمعرفة الرصيد!",
    goAccount: "الذهاب للحساب",
    toolLoading: "الأداة لا تزال تُحمّل...",
    victory: "فوز!",
    shareText: "فزت في لعبة الشيت المخفية!",
  },
  levelMap: {
    subHeader: "أكمل كل المستويات الـ 50 وافتح المكافآت!",
    silver: "شيت فضي",
    golden: "شيت ذهبي",
    diamond: "شيت ماسي",
    trophy: "كأس",
  },
};

export default ar;
